window.Blimp = window.Blimp || {};

const SEARCH_REQUESTS_TIMEOUT_IN_MS = 20000;
const SEARCH_REQUESTS_DEBOUNCE_IN_MS = 250;
const SEARCH_REQUESTS_STORE_DEBOUNCE_IN_MS = 2000;
const MAX_SEARCH_HISTORY_SIZE = 10;

class ControlView extends Backbone.View {
  get events() {
    return {
      'input #q': 'setKeyword'
    };
  }

  initialize() {
    this.data = {};
    this.setKeyword = this.setKeyword.bind(this);
    this.setDateRange = this.setDateRange.bind(this);
    this.setRefreshInterval = this.setRefreshInterval.bind(this);
    this.clearRefreshInterval = this.clearRefreshInterval.bind(this);
    this.refresh = this.refresh.bind(this);
    this.scroll = this.scroll.bind(this);
    this.toggleNoResults = this.toggleNoResults.bind(this);

    this.groups_view = new Blimp.GroupsView();
    $(window).scroll(this.scroll);

    $(window).focus(this.refresh);
    $(window).focus(this.setRefreshInterval);
    $(window).blur(this.clearRefreshInterval);
    this.setRefreshInterval();

    this.listenTo(Blimp.reports, 'add', this.toggleNoResults);
    this.listenTo(Blimp.reports, 'remove', this.toggleNoResults);
    this.toggleNoResults();

    $("#date").daterangepicker({
      verticalOffset: 20,
      datepickerOptions: {
        firstDay: 1,
        numberOfMonths: 1
      }
    }).daterangepicker({
      onChange: this.setDateRange
    });

    $("#q").autocomplete({
      minLength: 0,
      source: (request, response) => {
        const raw_history = localStorage.getItem("searchHistory");
        let history;
        if (raw_history) {
          history = JSON.parse(raw_history);
        } else {
          history = [];
        }
        response($.ui.autocomplete.filter(history, request.term));
      },
      select: (event, ui) => {
        $("#q").val(ui.item.value);
        $("#q").trigger("input");
      }
    });
    $("#q").on("click", () => {
      $("#q").autocomplete("search");
    });
  }

  setKeyword(e) {
    this.data.q = $(e.target).val();
    this.search();
  }

  setDateRange(options) {
    this.data.s = options.start && moment(options.start).format('YYYY-MM-DD');
    this.data.e = options.end && moment(options.end).format('YYYY-MM-DD');
    this.search();
  }

  search = _.debounce(function() {
    // Cancel possibly running request
    if (this.loading_request && [1, 2, 3].includes(this.loading_request.readyState)) {
      this.loading_request.abort();
    }

    this.is_loading = true;

    this.loading_request = Blimp.reports.fetch({
      data: this.data,
      // Timeout for requests in ms. Default 10000 was too low.
      timeout: SEARCH_REQUESTS_TIMEOUT_IN_MS,
      success: (_, __, options) => {
        if (options.xhr.status === 204) {
          this.reached_ground = true;
          Blimp.reports.set([]);
        } else {
          this.reached_ground = false;
        }

        this.clearRefreshInterval();
        this.setRefreshInterval();
      },
      complete: () => {
        this.saveSearchInHistory();
        this.is_loading = false;
      },
      error: (_, xhr) => {
        if (xhr.statusText === 'timeout') {
          alert('The search has timed out. Please try again.');
        }
        if (xhr.status === 500) {
          alert('There was an error. Please try again.');
        }
      }
    });
  }, SEARCH_REQUESTS_DEBOUNCE_IN_MS)

  saveSearchInHistory = _.debounce(function() {
    // Saving last searches in local storage
    const raw_history = localStorage.getItem("searchHistory");
    const searchphrase = this.data.q;
    let history;
    if (raw_history) {
      history = JSON.parse(raw_history);
    } else {
      history = [];
    }
    if (this.data.q?.length > 1) {
      history = history.filter((el) => el !== searchphrase);
      history = history.slice(0, MAX_SEARCH_HISTORY_SIZE - 1);
      history = [searchphrase].concat(history);
      localStorage.setItem("searchHistory", JSON.stringify(history));
    }
  }, SEARCH_REQUESTS_STORE_DEBOUNCE_IN_MS)

  setRefreshInterval() {
    this.clearRefreshInterval();
    this.timer = setInterval(() => {
      this.refresh();
    }, 5000);
  }

  clearRefreshInterval() {
    clearInterval(this.timer);
    this.timer = null;
  }

  refresh() {
    // Skip loading new when request running, zoom is up or user scrolled down
    if (this.is_loading) return;
    if (Blimp.zoom_view.is_up) return;
    if (Blimp.reports.first() && (document.documentElement.scrollTop || document.body.scrollTop) > $('.report').first().offset().top) return;

    this.is_loading = true;

    this.loading_request = Blimp.reports.fetch({
      remove: false,
      data: _.extend({}, this.data, {
        gt: Blimp.reports.isEmpty() ? '' : _.max(Blimp.reports.pluck('id'))
      }),
      complete: () => {
        this.is_loading = false;
      }
    });
  }

  scroll() {
    // Skip loading more when request running, ground has been reached or user did not scroll all the way down
    if (this.is_loading) return;
    if (this.reached_ground) return;
    if (Blimp.reports.isEmpty()) return;
    if (document.body.scrollHeight - 250 > (document.documentElement.scrollTop || document.body.scrollTop) + window.innerHeight) return;

    this.is_loading = true;

    const ids = Blimp.reports.pluck('id');
    const last_id = ids[ids.length - 1];

    this.loading_request = Blimp.reports.fetch({
      remove: false,
      data: _.extend({}, this.data, {
        last_fetched_id: last_id
      }),
      success: (_, __, options) => {
        this.reached_ground = (options.xhr.status === 204);
      },
      complete: () => {
        this.is_loading = false;
      }
    });
  }

  toggleNoResults() {
    $('.no-results').toggle(Blimp.reports.isEmpty());
  }
}

Blimp.ControlView = ControlView;
